import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
export const SpacesModel = Symbol('SpacesModel');
let SpacesModelImp = class SpacesModelImp extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    dispose() {
        this.update(() => []);
    }
};
SpacesModelImp = __decorate([
    injectable()
], SpacesModelImp);
export { SpacesModelImp };
